import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CSSProperties } from 'react';
import { Colors } from '../../../../theme/colors';

const AVAILABILITY_COLUMN_WIDTH = 72;
const AVATAR_HALF_WIDTH = 20;

export const useTimelineRowStyles = makeStyles<
  Theme,
  { dividerStyle?: CSSProperties['borderStyle']; alignTitle?: 'top' | 'middle'; hasAvailability?: boolean }
>({
  wrapper: {
    position: 'relative'
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: '1.4rem',
    position: 'relative',
    zIndex: 2
  },
  dividerStyle({ dividerStyle = 'solid' }) {
    return dividerStyle === 'dashed'
      ? {
          backgroundImage: "url('/images/Dash@2x.png')",
          backgroundRepeat: 'repeat-y',
          backgroundSize: '0.2rem',
          width: '5px'
        }
      : {
          borderLeft: `0.2rem ${dividerStyle} rgba(0,0,0,0.2)`
        };
  },
  divider: {
    position: 'absolute',
    height: 'calc(100% - (44px - 1.4rem))',
    top: '42px',
    left({ hasAvailability }) {
      return `${(hasAvailability ? AVAILABILITY_COLUMN_WIDTH : 0) + AVATAR_HALF_WIDTH}px`;
    },
    zIndex: 1
  },
  availability: {
    width: `${AVAILABILITY_COLUMN_WIDTH}px`,
    height: '40px',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px 0 0',
    fontSize: '13px',
    color: Colors.timelineGray
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 8px 0 0',
    position: 'relative',
    opacity: 1,
    zIndex: 2
  },
  content: {
    width: '100%',
    paddingTop({ alignTitle = 'top' }) {
      return alignTitle === 'middle' ? '8px' : undefined;
    }
  }
});
